import { render, staticRenderFns } from "./MentionMarkdown.vue?vue&type=template&id=0fed8627&"
import script from "./MentionMarkdown.vue?vue&type=script&lang=ts&"
export * from "./MentionMarkdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports